module.exports = __webpack_public_path__ + "static/media/sf-test-13.fee2675b.mp3";